import { memo as Memo, useEffect, useMemo } from 'react';
import { gsap, TimelineMax } from 'gsap';

//* Styles
import SharpyThankYouStyle from './style';

const SharpyThankYou = Memo(({ active }) => {
	const shaTRHYPath = useMemo(() => 'M133.92,123.13C136.5,135.5,119.5,157.5,77.5,155.5a63,63,0,0,0,4.42-4.94c2.58-3.06.58-8.06-5.42-5.06', []);
	const shaTLHYPath = useMemo(() => 'M17.88,121.33C14.5,133.5,27.5,155.5,70.5,155.5c-2-2-4-3.55-5.2-5.74-1.8-3.26.2-7.26,6.2-4.26', []);
	const anim = useMemo(() => new TimelineMax({ paused: true, repeat: -1, yoyo: true }), []);

	useEffect(() => {
		anim.set('.shaT-lex', { opacity: 0 }, 2.1)
			.set('.shaT-ley', { opacity: 1 }, 2.1)
			.set('.shaT-rex', { opacity: 0 }, 2.2)
			.set('.shaT-rey', { opacity: 1 }, 2.2)
			.to('.shaT-rhx', 1, { morphSVG: shaTRHYPath }, 2)
			.to('.shaT-lhx', 1, { morphSVG: shaTLHYPath }, 2);
	}, []);

	useEffect(() => {
		active && anim.progress(0).play();
	}, [active]);

	return (
		<SharpyThankYouStyle className={`sharpyThankYou`}>
			<svg viewBox='0 0 145 231.32'>
				<path
					className={`shaT-body body`}
					d='M145,184H-.43C-.43,82.38,64.69,0,145,0h0Z'
				/>
				<path
					className={`shaT-lf style1`}
					d='M69.91,182.5c.19,6,1,22.25,1.4,32.56a13,13,0,0,1-7.8,12.42l-5.38,2.34'
				/>
				<path
					className={`shaT-rf style1`}
					d='M87.7,184.8c.8,5.93,2.7,22.11,4,32.34a13,13,0,0,0,9.75,11l5.7,1.42'
				/>
				<path
					className={`shaT-m style2`}
					d='M65.65,105.69,71.51,123l5.89-17.33h4.68l-7.75,21.88H68.72L61,105.69Z'
				/>
				<path
					className={`shaT-lex style2`}
					d='M49.36,88.28l1.55,2.82-4.06,1.45L50.91,94l-1.64,2.91L46,94.1l.72,4.31H43.44l.68-4.31-3.34,2.82L39.07,94l4.06-1.46-4-1.42,1.58-2.82L44.12,91l-.71-4.3h3.26L46,91Z'
				/>
				<path
					className={`shaT-rex style2`}
					d='M102.62,88.28l1.55,2.82-4.06,1.45L104.17,94l-1.64,2.91L99.21,94.1l.71,4.31H96.7l.68-4.31L94,96.92,92.33,94l4.06-1.46-4-1.42L94,88.28,97.38,91l-.71-4.3h3.25L99.21,91Z'
				/>

				<g className={`shaT-ley hideOpacity`}>
					<path
						className={`style2`}
						d='M36.49,100,30.61,94l5.88-6.07h4.78L35.36,94,41.27,100Z'
					/>
					<path
						className={`style2`}
						d='M53,84.46a4.87,4.87,0,0,1,2.11,1.86A5.08,5.08,0,0,1,55.77,89a4.48,4.48,0,0,1-1,3,4.25,4.25,0,0,1-2.64,1.44v.14q4,1.18,4,4.69a5.22,5.22,0,0,1-1.64,4,6.63,6.63,0,0,1-4.65,1.52,7.64,7.64,0,0,1-5.08-1.58,6.47,6.47,0,0,1-2.1-4.76h3.73a3.64,3.64,0,0,0,.95,2.31,3.14,3.14,0,0,0,2.34.85,2.74,2.74,0,0,0,2-.72A2.5,2.5,0,0,0,52.42,98a2.4,2.4,0,0,0-1.05-2.1,5.42,5.42,0,0,0-3.1-.73h-.79V92h.79c2.52,0,3.77-.83,3.77-2.62a2.43,2.43,0,0,0-.67-1.82,2.51,2.51,0,0,0-1.84-.66,2.72,2.72,0,0,0-2,.77,3.2,3.2,0,0,0-.89,2.15H42.92a6.31,6.31,0,0,1,1.89-4.5,6.87,6.87,0,0,1,4.81-1.58A7.58,7.58,0,0,1,53,84.46Z'
					/>
				</g>

				<g className={`shaT-rey hideOpacity`}>
					<path
						className={`style2`}
						d='M92,100,86.15,94,92,87.89h4.78L90.9,94,96.81,100Z'
					/>
					<path
						className={`style2`}
						d='M108.49,84.46a4.87,4.87,0,0,1,2.11,1.86,5.08,5.08,0,0,1,.71,2.65,4.48,4.48,0,0,1-1,3,4.25,4.25,0,0,1-2.64,1.44v.14q4,1.18,4,4.69a5.22,5.22,0,0,1-1.64,4,6.63,6.63,0,0,1-4.65,1.52,7.64,7.64,0,0,1-5.08-1.58,6.47,6.47,0,0,1-2.1-4.76h3.73a3.64,3.64,0,0,0,1,2.31,3.14,3.14,0,0,0,2.34.85,2.74,2.74,0,0,0,2-.72A2.5,2.5,0,0,0,108,98a2.4,2.4,0,0,0-1-2.1,5.42,5.42,0,0,0-3.1-.73H103V92h.79c2.52,0,3.77-.83,3.77-2.62a2.43,2.43,0,0,0-.67-1.82,2.51,2.51,0,0,0-1.84-.66,2.72,2.72,0,0,0-2,.77,3.2,3.2,0,0,0-.89,2.15H98.46a6.31,6.31,0,0,1,1.89-4.5,6.87,6.87,0,0,1,4.81-1.58A7.58,7.58,0,0,1,108.49,84.46Z'
					/>
				</g>

				<path
					className={`shaT-lhx style3`}
					d='M17.88,121.33C10.4,128.81-4.75,153.93,47.33,155q3.31.08,7,0t7.78-.28'
				/>
				<path
					className={`shaT-rhx style3`}
					d='M133.92,123.13c7.48,7.49,18.12,30.8-34,31.85q-3.3.08-7,0t-7.78-.28'
				/>
			</svg>
		</SharpyThankYouStyle>
	);
});

export default SharpyThankYou;
